import { Injectable } from '@angular/core';
import { LocalDbService } from '../local-db-service';
import { Warehouse } from '../../entities/warehouse';

@Injectable({ providedIn: 'root' })
export class WarehouseRepository {
  private get table() {
    return this.db.warehouseTable;
  }

  constructor(private readonly db: LocalDbService) {}

  async getAll(): Promise<Warehouse[]> {
    const rows = await this.table.toArray();
    return rows.map(row => new Warehouse(row));
  }

  async getById(id: number): Promise<Warehouse | undefined> {
    const row = await this.table.get(id);
    return row ? new Warehouse(row) : undefined;
  }

  async getByUserManagerId(id: number, regionId: number): Promise<Warehouse | undefined> {
    const row = await this.table.filter(row => row.warehouseManagerId === id && row.regionId === regionId).first();
    return row ? new Warehouse(row) : undefined;
  }

  async getByRegionId(regionId: number): Promise<Warehouse[]> {
    const rows = await this.table.where('regionId').equals(regionId).toArray();
    return rows.map(row => new Warehouse(row));
  }

  upsert(warehouse: Warehouse): Promise<number> {
    return this.table.put(warehouse);
  }

  upsertBulk(warehouses: Warehouse[]): Promise<number> {
    return this.table.bulkPut(warehouses);
  }

  delete(id: number): Promise<void> {
    return this.table.delete(id);
  }

  clear(): Promise<void> {
    return this.table.clear();
  }
}